import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
    listRoot: {
      height: '100%',
      marginTop: 10,
      maxHeight: 300,
      overflowY: 'scroll',
    },
    avatar: {
      backgroundColor: theme.palette.success.main,
    },
    loadingContainer: {
      height: 150,
      width: '100%',
    },
    container: {
      alignItems: 'center',
      backgroundColor: '#F4F5F766',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      marginBottom: '15px',
      padding: '8px 16px 8px 12px',
      width: '100%',
    },
    USERCANCELLED: {
      color: theme.palette.reservation_status.cancelled,
      borderLeft: `4px solid ${theme.palette.reservation_status.cancelled}`,
    },
    ADMINCANCELLED: {
      color: theme.palette.reservation_status.cancelled,
      borderLeft: `4px solid ${theme.palette.reservation_status.cancelled}`,
    },
    COMPLETED: {
      color: theme.palette.reservation_status.completed,
      borderLeft: `4px solid ${theme.palette.reservation_status.completed}`,
    },
    RESERVED: {
      color: theme.palette.reservation_status.reserved,
      borderLeft: `4px solid ${theme.palette.reservation_status.reserved}`,
    },
    NOSHOW: {
      color: theme.palette.reservation_status.noshow,
      borderLeft: `4px solid ${theme.palette.reservation_status.noshow}`,
    },
    REJECTED: {
      color: theme.palette.reservation_status.rejected,
      borderLeft: `4px solid ${theme.palette.reservation_status.rejected}`,
    },
    INPROGRESS: {
      color: theme.palette.reservation_status.inProgress,
      borderLeft: `4px solid ${theme.palette.reservation_status.inProgress}`,
    },

    status: {
      borderWidth: '0 !important',
    },

    textSecondary: {
      color: theme.palette.text.subtitle,
      lineHeight: 1,
    },

    timezone: {
      color: theme.palette.secondary.light,
      display: 'block',
    },

    header: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 4,
    },

    footer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      '& p': {
        lineHeight: 1.2,
      },
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 8,
    },

    list: {
      alignItems: 'flex-start',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginTop: 20,
      width: '100%',
    },

    listItem: {
      width: '100%',
      padding: '8px 4px 8px 0',
      '&:not(:last-of-type)': {
        borderBottom: '1px solid #EEEEEE',
      },
    },
    textSubtitle: {
      color: theme.palette.text.subtitle,
    },

    lineHeight: {
      lineHeight: 1,
    },
    button: {
      fontSize: theme.typography.pxToRem(13),
      textTransform: 'inherit',
      marginRight: 12,
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: 0,
      padding: '0 4px',
    },
    primary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 'bold',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      wordBreak: 'break-word',
    },
  };
});

export { useStyles, listTextStyles };
